import { IconInfo } from '@gmg/gmg-react-components';
import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppContext from 'src/AppContext';
import styled from 'styled-components';

export const repairLicenseSystemNotificationToastId = 'RepairLicenseSystemNotificationToastId';

export const RepairLicenseSystemNotificationToast = () => {
    const { t } = useTranslation();
    const context = useContext(AppContext);

    return (
        <Main>
            <IconInfo width={22} height={22} />
            <Content>
                <span className="px12_400_normal">
                    {t('RepairLicenseSystemNotificationToast.notification_title', 'Creating repair file...')}
                </span>
                <span className="px10_400_normal">
                    {t('RepairLicenseSystemNotificationToast.paragraph1_desc', 'Your repair file is being created. This can take up to a minute. You will get a notification once it is ready for download.')}
                </span>
                <span className="px10_400_normal">
                    <Trans t={t} i18nKey={'RepairLicenseSystemNotificationToast.paragraph2_desc'} className="px10_400_normal">
                        For more information on repairing license systems, please refer to our&nbsp;
                        <ColoredLink
                            aria-label="call to helpCenter button"
                            to={context.language === 'de'
                                ? 'https://customercare.gmgcolor.com/hc/de-de/articles/31531181801883-Online-Licensing-im-Offline-Modus'
                                : 'https://customercare.gmgcolor.com/hc/en-us/articles/31531181801883-Online-Licensing-in-Offline-Mode-High-Security-Systems'
                            }
                            target="_blank"
                            rel="noreferrer"
                        >
                            Help Center
                        </ColoredLink>
                    </Trans>
                </span>
            </Content>
        </Main>
    );
};

const Main = styled.div`
    display: flex;
    margin: auto 0;
    gap: 16px;
    padding: 0px 24px 16px 8px;
`;

const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
`;

const ColoredLink = styled(Link)`
    color: ${props => props.theme.colors.highlight};
`;